import React from 'react';
import { map } from 'ramda';

import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

import { grey300, grey500, red500 } from 'material-ui/styles/colors';

const Select = props => {
  const {
    input,
    label,
    helperText,
    hintText,
    meta,
    items,
    withEmptyItem,
    onChangeFn,
    style,
    ...custom
  } = props;

  const { touched, error, warning } = meta || {};

  const childItems = withEmptyItem ? [{ key: 'NONE', value: null, label: '' }, ...items] : items;

  const err = touched && (error || (warning && warning.language));
  return (
    <div>
      <SelectField
        hintText={hintText}
        floatingLabelText={label}
        floatingLabelFixed
        underlineStyle={{ borderColor: err ? red500 : grey300, borderBottomWidth: err ? '2px' : '1px' }}
        underlineFocusStyle={{ borderBottomWidth: '2px' }}
        errorText={!helperText && err}
        {...input}
        onChange={(event, index, value) => {
          input && input.onChange(value);
          input && input.onBlur(value);
          if (onChangeFn) {
            onChangeFn(value);
          }
        }}
        onBlur={() => input && input.onBlur(input.value)}
        style={{
          fontSize: '0.875em',
          ...style
        }}
        children={map(i => (
          <MenuItem key={i.key || i.value} value={i.value} primaryText={i.label} />
        ), childItems)}
        {...custom}
      />
      {helperText && (
        <p
          style={{
            color: err ? red500 : grey500,
            fontSize: '0.75em',
            lineHeight: '0.75em',
            marginTop: '-1px',
            marginBottom: 0
          }}
        >
          {helperText}
        </p>
      )}
    </div>
  );
};

export default Select;



// WEBPACK FOOTER //
// ./src/components/basic/SelectField.js